import { render, staticRenderFns } from "./DashboardOI.vue?vue&type=template&id=7b62057e&scoped=true&"
import script from "./DashboardOI.vue?vue&type=script&lang=js&"
export * from "./DashboardOI.vue?vue&type=script&lang=js&"
import style0 from "./DashboardOI.vue?vue&type=style&index=0&id=7b62057e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b62057e",
  null
  
)

export default component.exports